"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsafe_dynamicTranslate = exports.getBrowserLanguage = exports.setLocale = exports.injectLoaders = void 0;
const constants_js_1 = require("./constants.js");
const LanguageCache_js_1 = require("./LanguageCache.js");
const injectLoaders = (loaders) => LanguageCache_js_1.languageCache.injectLoaders(loaders);
exports.injectLoaders = injectLoaders;
const setLocale = (locale) => LanguageCache_js_1.languageCache.set(locale);
exports.setLocale = setLocale;
const getBrowserLanguage = () => globalThis.navigator.language ?? constants_js_1.DEFAULT_LOCALE;
exports.getBrowserLanguage = getBrowserLanguage;
// eslint-disable-next-line @typescript-eslint/naming-convention
const unsafe_dynamicTranslate = (key, values, fallbackText) => {
    if (fallbackText !== undefined && !LanguageCache_js_1.languageCache.keyExists(key)) {
        const actionSegment = typeof fallbackText === 'string'
            ? `Using fallbackText: "${fallbackText}"`
            : `Ignoring`;
        console.warn(`Translation missing for translation key: "${key}". ${actionSegment}.`);
        return fallbackText;
    }
    return LanguageCache_js_1.languageCache.translate(key, values);
};
exports.unsafe_dynamicTranslate = unsafe_dynamicTranslate;
//# sourceMappingURL=utilities.js.map